import { render, staticRenderFns } from "./hapus_rka.vue?vue&type=template&id=21dac7e0&"
import script from "./hapus_rka.vue?vue&type=script&lang=js&"
export * from "./hapus_rka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports